module.exports = __webpack_public_path__ + "static/media/logo1.6c64508e.png";